/**
 * Copyright © PlanMaster Fogászati Szoftver Kft. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Tamas Neufeld <tamas.neufeld@planmaster3d.com>, 2018
 */

const toolbarMixin = {
    mounted: function() {
        this.updateToolbar();
    },
    activated: function() {
        this.updateToolbar();
    },
    methods: {
        updateToolbar: function() {
            const toolbar = this.$options.toolbar;
            if (toolbar && typeof toolbar === 'function') {
                let data = toolbar.call(this);
                this.$store.state.toolbar.active = data[1];
                this.$store.commit('toolbar/setItems', data[0]);
                this.$store.commit('toolbar/show');
                this.$bus.$emit('app-buttonbar:update', data[0]);
            }
        },
    },
};

export default toolbarMixin;
